import { render, staticRenderFns } from "./ZDMCustomReportsList.vue?vue&type=template&id=4f2c1dd0&scoped=true&"
import script from "./ZDMCustomReportsList.vue?vue&type=script&lang=js&"
export * from "./ZDMCustomReportsList.vue?vue&type=script&lang=js&"
import style0 from "./ZDMCustomReportsList.vue?vue&type=style&index=0&id=4f2c1dd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2c1dd0",
  null
  
)

export default component.exports